import React from 'react';
import Container from '../../shared/Containers/Container';
import './AboutPage.css'

const About = () => {
    return (
        <Container scroll>
            <h1 className="AboutTitle" style={{ color: "white" }}>About Us</h1>
            <div className="MainDiv" >
                <div className="TextDiv">
                    <div>
                        <h5 className="BodyText">
                            Web Games Portal started at 2017 as a portal of online games based on HTML5 from different reputed sources to provide a quality instant gaming experience.
                            All games in this site belongs to their respective owners. We are in frequent search for best HTML5 games to help our players to have more fun
                            leaving frustrations of finding better games to us. So far we have collected more than 1400+ games and still counting.
                            List of our game providers:-
                    </h5>

                        <ul className="ListItem">
                            <li><a href="https://cloudgames.com"> Cloud Games</a></li>
                            <li><a href="https://www.gamepix.com/"> Gamepix</a></li>
                        </ul>
                        <h5 className="BodyText">Web Games Portal was created by Safal and is managed by a group of some high schoolers from Nepal. If you have any questions or any suggestions regarding our service, feel free to mail us <a href="mailto:safal.sharma.ss@gmail.com">@safal.sharma.ss@gmail.com</a> or message us in our Facebook Page.</h5>
                    </div>
                </div>
                <div>
                    {/*  style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowtransparency="true" allow="encrypted-media" */}
                    <iframe allowTransparency={true} className="FacebookFrame" scrolling="no" frameBorder="no" allow="encrypted-media" title="facebook" src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fwebgamesportal&amp;tabs&amp;width=340&amp;height=220&amp;small_header=false&amp;adapt_container_width=true&amp;hide_cover=false&amp;show_facepile=true&amp;appId=563593387326851"
                    ></iframe>
                </div>
            </div>
        </Container>
    )
}

export default About;
